

<div class="category">
    <div class="loading" *ngIf="loading">
        <img src="../../assets/img/ExcessMaterialLoading.png" alt="">
        <h1>LOADING...</h1>
    </div>
    <div *ngIf="!loading">
        <button *ngIf="(next === true || prev === true) else notShown" class="arrows" (click)="turnPageLeft(prev, next, lastPage)">←</button>
        <ng-template #notShown>
            <button class="arrows" style="visibility:hidden;">←</button>
        </ng-template>
        <section>
        <button *ngIf="(!single && items.length > 0)  else isSingle" (click)="clickHandler()">{{cat | titlecase}}</button>
        <ng-template #isSingle>
            <h2>{{cat | titlecase}}</h2>
        </ng-template>
        <h3 *ngIf="lastPage !== 0">Page {{ pageNum }} of {{ lastPage }}</h3>
        </section>
        <button *ngIf="(next === true || prev === true) else notShown" class="arrows"  (click)="turnPageRight(prev, next, lastPage)">→</button>
        <ng-template #notShown>
            <button class="arrows" style="visibility:hidden;">→</button>
        </ng-template>
    </div>
    <section *ngIf="!loading">
        <app-item [seller]="items[i].user_id" *ngFor="let item of items; index as i" [merchandise]="items[i]"></app-item>
    </section>
    <h3 class='emptyMessage' *ngIf="items.length === 0 && !loading">There are no results.</h3>
</div>